import type { ImageWidget } from "~/types/widgets"
import { Picture, Source } from "~/components/ui/Picture"

interface Sizes {
    /**
     * @title Largura
     */
    width: number
    /**
     * @title Altura
     */
    height: number
}

/**
 * @title Logo
 */
export interface Props {
    /**
     * @title Imagem
     */
    image: ImageWidget
    /**
     * @title Texto alternativo
     */
    alt: string
    desktop: Sizes
    mobile: Sizes
}

export default function Logo({ image, alt, desktop, mobile }: Props) {
    return (
        <Picture className='grid place-content-center min-[1220px]:pl-6 shrink-0 h-fit'>
            <Source
                media='(max-width: 767px)'
                fetchPriority='auto'
                src={image}
                width={mobile.width}
                height={mobile.height}
            />
            <Source
                media='(min-width: 768px)'
                fetchPriority='auto'
                src={image}
                width={desktop.width}
                height={desktop.height}
            />
            <img
                className='object-cover'
                loading='lazy'
                src={image}
                alt={alt ?? 'Logo da loja Miess'}
            />
        </Picture>
    )
}
